var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckboxIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 59,
    viewBox: "0 0 77 59",
    width: 77,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#eb4f92"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.5,
    cy: 30.5,
    rx: 26.5,
    ry: 26.5,
    transform: "matrix(-1 0 0 -1 101 61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.0001,
    cy: 43,
    opacity: 0.3,
    rx: 16,
    ry: 16,
    transform: "matrix(-1 0 0 -1 56.0002 86)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.5001,
    cy: 16.5,
    opacity: 0.12,
    rx: 16.5,
    ry: 16.5,
    transform: "matrix(-1 0 0 -1 43.0002 33)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m47 33.5c0 12.9468-10.4988 23.5-23.5 23.5s-23.5-10.5532-23.5-23.5 10.4988-23.5 23.5-23.5 23.5 10.5532 23.5 23.5zm-7.7245-4.9502c0-.544-.1632-1.0336-.544-1.4144l-2.7743-2.7743c-.3808-.3264-.8704-.544-1.36-.544-.544 0-1.0335.2176-1.4143.544l-12.4572 12.4572-6.9086-6.9086c-.3808-.3808-.8703-.5984-1.4143-.5984-.4896 0-.9792.2176-1.36.5984l-2.77428 2.7743c-.38079.3808-.54398.8704-.54398 1.4144 0 .4896.16319.9791.54398 1.3599l11.09718 11.0973c.3264.3263.8704.5439 1.36.5439s1.0336-.2176 1.4143-.5439l16.5915-16.6459c.3808-.3808.544-.8703.544-1.3599z",
    fill: "#f5dfe8",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxIcon);
export default __webpack_public_path__ + "static/media/checkbox_icon.5b2d3102dd1ffbb41164edc30592a2c7.svg";
export { ForwardRef as ReactComponent };